// extracted by mini-css-extract-plugin
module.exports = {"container":"container__2vqLY","mobile":"mobile__27-2l","tablet":"tablet__3ai14","desktop":"desktop__2I3Tk"};